import React, { useRef } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import BgImg from "../../images/services-usa/ionic-app/ionic-banner.webp";

function Banner(props) {
  return (
    <div
      className="service_usa web_dev_service healthcare_banner android_banner chatbot_banner"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={8} lg={8} xl={8} xxl={7} className="my-auto">
            <div className="banenr_content">
              <h1 className="web_head_banner" style={{ marginBottom: "10px" }}>
                Ionic App Development Services
              </h1>
              <span>
                Develop{" "}
                <span style={{ color: "#F47A14" }}>
                  Cross-Platform Ionic Applications
                </span>{" "}
                For Your Business
              </span>
              <p style={{ marginTop: "10px" }}>
                TekRevol specializes in creating top-notch ionic applications
                using open-source UI toolkits across different platforms. From
                mobiles to web and desktop applications, we aim to give you the
                most proficient ionic applications to unleash a whole new niche
                market that assures long-term sustainable growth for the
                business.
              </p>

              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Book a call with our Ionic Developers
              </Link>
              <Link
                style={{ border: "2px solid #f47a14" }}
                to="/contact"
                className="border_btn web_case_btn"
                aria-label="Discuss Project Needs"
              >
                Book a Slot for Consultation
              </Link>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
